import { APIClient } from "../api";

export default class UserSessionHistoryService extends APIClient {

    constructor(props: any) {
        super(props);
    }

    async saveAccess(data: any) {
        const url = `${this.endpoint}/UserSessionHistory`;

        return this.api({
            method: 'post',
            url,
            data: data
        });
    }
}